import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandAreaMaintenanceTypesInputDto, StandAreaMaintenanceTypeCreateDto, StandAreaMaintenanceTypeDto, StandAreaMaintenanceTypeExcelDownloadDto, StandAreaMaintenanceTypeUpdateDto } from '../dtos/stand-area-maintenance-type/models';

@Injectable({
  providedIn: 'root',
})
export class StandAreaMaintenanceTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: StandAreaMaintenanceTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandAreaMaintenanceTypeDto>({
      method: 'POST',
      url: '/api/planning/standAreaMaintenanceTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/standAreaMaintenanceTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/standAreaMaintenanceTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandAreaMaintenanceTypeDto>({
      method: 'GET',
      url: `/api/planning/standAreaMaintenanceTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/standAreaMaintenanceTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandAreaMaintenanceTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandAreaMaintenanceTypeDto>>({
      method: 'GET',
      url: '/api/planning/standAreaMaintenanceTypes',
      params: { name: input.name, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandAreaMaintenanceTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/standAreaMaintenanceTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandAreaMaintenanceTypeDto[]>({
      method: 'GET',
      url: '/api/planning/standAreaMaintenanceTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandAreaMaintenanceTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandAreaMaintenanceTypeDto>({
      method: 'PUT',
      url: `/api/planning/standAreaMaintenanceTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}